export default "__VITE_ASSET__a63adb2e__"